<template>
  <div class="settings">
    <SettingsPage></SettingsPage>
  </div>
</template>

<script>
import SettingsPage from '@/components/SettingsPage.vue';

export default {
  name: 'settingsView',
  components: {
    SettingsPage
  }
}
</script>
